// extracted by mini-css-extract-plugin
export default {"menuBlock":"pF-z","title":"qF-z","nav":"rF-z","flexCell":"sF-z","facetLink":"tF-z"};